import { render, staticRenderFns } from "./ShortcutWebpart.vue?vue&type=template&id=4df2bd24&scoped=true"
import script from "./ShortcutWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ShortcutWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./ShortcutWebpart.vue?vue&type=style&index=0&id=4df2bd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2bd24",
  null
  
)

export default component.exports